// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-avatar, .contact-list-avatar, .account-setting-avatar {
  height: 2.5rem;
  width: 2.5rem;
  cursor: pointer;
  margin-right: 0.1875rem;
}
@media (max-width: 576px) {
  .toolbar-avatar, .contact-list-avatar, .account-setting-avatar {
    height: 2rem;
    width: 2rem;
  }
}
.toolbar-avatar span, .contact-list-avatar span, .account-setting-avatar span {
  font-size: 0.75rem;
  font-weight: normal;
}

.account-setting-avatar {
  margin-right: 1rem;
  height: 2.5rem;
  width: 2.5rem;
}
@media (max-width: 319px) {
  .account-setting-avatar {
    display: inherit;
  }
}

.contact-avatar {
  display: flex;
  overflow: hidden;
  margin-right: 0.5rem !important;
  height: 2rem;
  width: 2rem;
  position: relative;
  cursor: pointer;
}
.contact-avatar span {
  font-size: 1rem;
}

.user-avatar, .contact-details-card-avatar, .calling-avatar {
  height: 5rem;
  width: 5rem;
  cursor: pointer;
  margin-bottom: 2.5rem;
}
@media (max-width: 576px) {
  .user-avatar, .contact-details-card-avatar, .calling-avatar {
    height: 4.625rem;
    width: 4.625rem;
    margin-bottom: 2.375rem;
  }
}
.user-avatar span, .contact-details-card-avatar span, .calling-avatar span {
  font-size: 2.5rem;
}

.calling-avatar {
  margin-top: 1.75rem;
  cursor: none;
}

.contact-details-card-avatar {
  margin-top: 0rem;
  margin-bottom: 1rem;
  height: 4.5rem;
  width: 4.5rem;
  -webkit-user-select: none;
          user-select: none;
  cursor: unset;
}

.room-avatar, .setup-avatar, .room-avatar-presentation {
  margin: 0 calc(50% - 2rem);
  top: calc(50% - 2rem - 0.25rem);
  width: 4rem;
  height: 4rem;
  position: absolute;
  z-index: 1;
}
.room-avatar span, .setup-avatar span, .room-avatar-presentation span {
  font-size: 2.1875rem;
}

.room-avatar-presentation {
  top: 0;
  width: 6.25rem;
  height: 6.25rem;
  margin-left: calc(50% - 3.125rem);
  margin-top: calc((var(--room-presentation-video-height-fixed) - 6.25rem) / 2);
}
.room-avatar-presentation span {
  font-size: 3.125rem;
}

.room-avatar-collaboration {
  width: 6.25rem;
  height: 6.25rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  left: 50%;
  margin: 0;
  z-index: 2;
}
.room-avatar-collaboration span {
  font-size: 3.125rem;
}

.setup-avatar {
  margin: 0;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-weight: normal;
}
@media (max-width: 576px) {
  .setup-avatar {
    height: 3.75rem;
    width: 3.75rem !important;
  }
  .setup-avatar span {
    font-size: 1.875rem;
  }
}

.main-avatar {
  margin: 32vh auto;
  width: 24vh;
  height: 24vh;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
}
.main-avatar span {
  font-size: 12vh;
}
.main-avatar img {
  color: var(--text-primary);
}

span {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: lightcoral;
  color: #FFF;
}

div {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20%;
  overflow: hidden;
  position: relative;
}

.avatar-hidden {
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  overflow: hidden !important;
  opacity: 0;
}

div span {
  border-radius: 20%;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}

div img {
  border-radius: 20%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-online-icon-container {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.9375rem;
  width: 0.9375rem;
  background-color: #fff;
  border-radius: 50%;
  top: 1.3rem;
  right: -0.2062rem;
}

.avatar-online-icon {
  font-size: 0.8rem;
}

.messaging-list-avatar {
  height: 3rem;
  width: 3rem;
}

.contact-avatar {
  height: 2rem;
  width: 2rem;
}

.contact-list-avatar {
  height: 2rem;
  width: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/avatar/avatar.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AACJ;AACI;EANJ;IAOQ,YAAA;IACA,WAAA;EAEN;AACF;AAAI;EACI,kBAAA;EACA,mBAAA;AAER;;AAIA;EAEI,kBAAA;EACA,cAAA;EACA,aAAA;AAFJ;AAII;EANJ;IAOS,gBAAA;EADP;AACF;;AAIA;EACI,aAAA;EACA,gBAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAGI;EACI,eAAA;AADR;;AAKA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AAFJ;AAII;EANJ;IAOQ,gBAAA;IACA,eAAA;IACA,uBAAA;EADN;AACF;AAGI;EACI,iBAAA;AADR;;AAKA;EAEI,mBAAA;EACA,YAAA;AAHJ;;AAMA;EAEI,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;AAJJ;;AAQA;EACE,0BAAA;EACA,+BAAA;EACA,WAJiB;EAKjB,YALiB;EAMjB,kBAAA;EACA,UAAA;AALF;AAOE;EACE,oBAAA;AALJ;;AASA;EAGE,MAAA;EACA,cAHmB;EAInB,eAJmB;EAMnB,iCAAA;EACA,6EAAA;AATF;AAWE;EACE,mBAAA;AATJ;;AAaA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,4CAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAVJ;AAYI;EACI,mBAAA;AAVR;;AAcA;EAEI,SAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,mBAAA;AAZJ;AAcI;EARJ;IASQ,eAAA;IACA,yBAAA;EAXN;EAaM;IACI,mBAAA;EAXV;AACF;;AAeA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA;AAZJ;AAcI;EACI,eAAA;AAZR;AAeI;EACI,0BAAA;AAbR;;AAiBA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,WAAA;AAdJ;;AAiBA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,UAAA;AAdJ;;AAiBA;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAdJ;;AAiBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAdJ;;AAiBA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAdJ;;AAiBA;EACI,iBAAA;AAdJ;;AAiBA;EACE,YAAA;EACA,WAAA;AAdF;;AAiBA;EACE,YAAA;EACA,WAAA;AAdF;;AAiBA;EAEE,YAAA;EACA,WAAA;AAfF","sourcesContent":[".toolbar-avatar {\n    height: 2.5rem;\n    width: 2.5rem;\n    cursor: pointer;\n    margin-right: 0.1875rem;\n\n    @media(max-width: 576px) {\n        height: 2rem;\n        width: 2rem;\n   }\n\n    span {\n        font-size: 0.75rem;\n        font-weight: normal;\n    }\n}\n\n\n\n.account-setting-avatar {\n    @extend .toolbar-avatar;\n    margin-right: 1rem;\n    height: 2.5rem;\n    width: 2.5rem;\n\n    @media(max-width: 319px) {\n         display: inherit;\n    }\n}\n\n.contact-avatar {\n    display: flex;\n    overflow: hidden;\n    margin-right: 0.5rem !important;\n    height: 2rem;\n    width: 2rem;\n    position: relative;\n    cursor: pointer;\n\n    span {\n        font-size: 1rem;\n    }\n}\n\n.user-avatar {\n    height: 5rem;\n    width: 5rem;\n    cursor: pointer;\n    margin-bottom: 2.5rem;\n\n    @media(max-width: 576px) {\n        height: 4.625rem;\n        width: 4.625rem;\n        margin-bottom: 2.375rem;\n    }\n\n    span {\n        font-size: 2.5rem;\n    }\n}\n\n.calling-avatar {\n    @extend .user-avatar;\n    margin-top: 1.75rem;\n    cursor: none;\n}\n\n.contact-details-card-avatar {\n    @extend .user-avatar;\n    margin-top: 0rem;\n    margin-bottom: 1rem;\n    height: 4.5rem;\n    width: 4.5rem;\n    user-select: none;\n    cursor: unset;\n}\n\n$room-avatar-size: 4rem;\n.room-avatar {\n  margin: 0 calc(50% - 2rem);\n  top: calc(50% - 2rem - 0.25rem);\n  width: $room-avatar-size;\n  height: $room-avatar-size;\n  position: absolute;\n  z-index: 1;\n\n  span {\n    font-size: 2.1875rem;\n  }\n}\n\n.room-avatar-presentation {\n  $room-avatar-size: 6.25rem;\n  @extend .room-avatar;\n  top: 0;\n  width: $room-avatar-size;\n  height: $room-avatar-size;\n\n  margin-left: calc(50% - $room-avatar-size / 2);\n  margin-top: calc((var(--room-presentation-video-height-fixed) - $room-avatar-size) / 2);\n\n  span {\n    font-size: 3.125rem;\n  }\n}\n\n.room-avatar-collaboration {\n    width: 6.25rem;\n    height: 6.25rem;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%) translateX(-50%);\n    left: 50%;\n    margin: 0;\n    z-index: 2;\n\n    span {\n        font-size: 3.125rem;\n    }\n}\n\n.setup-avatar {\n    @extend .room-avatar;\n    margin: 0;\n    top: 50%;\n    left: 50%;\n    transform: translateY(-50%) translateX(-50%);\n    font-weight: normal;\n\n    @media(max-width: 576px) {\n        height: 3.75rem;\n        width: 3.75rem !important;\n\n        span {\n            font-size: 1.875rem;\n        }\n    }\n}\n\n.main-avatar {\n    margin: 32vh auto;\n    width: 24vh;\n    height: 24vh;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    z-index: 1;\n    transform: translateX(-50%);\n\n    span {\n        font-size: 12vh;\n    }\n\n    img {\n        color: var(--text-primary)\n    }\n}\n\nspan {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: lightcoral;\n    color: #FFF;\n}\n\ndiv {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 20%;\n    overflow: hidden;\n    position: relative;\n}\n\n.avatar-hidden {\n    position: absolute !important;\n    width: 0 !important;\n    height: 0 !important;\n    overflow: hidden !important;\n    opacity: 0;\n}\n\ndiv span {\n    border-radius: 20%;\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: 100%;\n}\n\ndiv img {\n    border-radius: 20%;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.avatar-online-icon-container {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 0.9375rem;\n    width: 0.9375rem;\n    background-color: #fff;\n    border-radius: 50%;\n    top: 1.3rem;\n    right: -0.2062rem;\n}\n\n.avatar-online-icon {\n    font-size: 0.8rem;\n}\n\n.messaging-list-avatar {\n  height: 3rem;\n  width: 3rem;\n}\n\n.contact-avatar {\n  height: 2rem;\n  width: 2rem;\n}\n\n.contact-list-avatar {\n  @extend .toolbar-avatar;\n  height: 2rem;\n  width: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
